import { localesModulesPT } from '@modules/locales'
import { localesComponentsPT } from 'ui-components/locales'

const locales = {
  ...localesModulesPT,
  ...localesComponentsPT,
}

export default locales
